import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { TRANSFER_TYPE_TO_SHORT_LABEL } from "../constants"

import { TransferType } from "@/graphql/codegen/graphql"

const TYPE_TO_CHIP_CLASS: Record<TransferType, string> = {
  [TransferType.IntraWarehouse]: "bg-primary-200",
  [TransferType.InterWarehouse]: "bg-tertiary-purple-300",
} as const

interface TransferTypeChipProps {
  type: TransferType
}

export const TransferTypeChip: FC<TransferTypeChipProps> = ({ type }) => (
  <Chip
    className={twMerge("h-6 rounded text-xs", TYPE_TO_CHIP_CLASS[type])}
    label={TRANSFER_TYPE_TO_SHORT_LABEL[type]}
    size='small'
  />
)
